module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/sixoneimportlandproc/sixoneimportlandproc.component.css
// module id = ./src/app/landprocurement/sixoneimportlandproc/sixoneimportlandproc.component.css
// module chunks = main